import React, { useEffect } from "react";
import {
  Grid,
  CircularProgress,
  Alert,
  Card,
  CardContent,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import CountUp from "react-countup";

const StatCard = ({ item }) => (
  <Tooltip title={item.tooltip} arrow placement="top">
    <Card
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 3,
        boxShadow: 3,
        height: 120,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            bgcolor: item.bgColor,
            color: item.iconColor,
            borderRadius: "50%",
            width: 70,
            height: 70,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.icon}
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="h6" fontWeight="bold" fontSize={28}>
            <CountUp
              start={0}
              end={Number(item.value.toString().replace(/\s/g, ""))} // handle numbers with spaces
              duration={1.5}
              separator=" "
            />
          </Typography>
        </Box>
      </Box>
    </Card>
  </Tooltip>
);

const Parents = ({ stats, loading, isError }) => {
  if (loading) return <CircularProgress />;
  if (isError) return <Alert severity="error">Failed to load parents</Alert>;

  const data = [
    {
      label: "Total Parents",
      value: stats?.totalParents || 0,
      icon: <PeopleIcon fontSize="large" />,
      iconColor: "#1976d2",
      bgColor: "#e3f2fd",
      tooltip: "Nombre total de parents",
    },
    {
      label: "Active Parents Subscription",
      value: stats?.parentsWithActiveSubscriptions || 0,
      icon: <CheckCircleIcon fontSize="large" />,
      iconColor: "#2e7d32",
      bgColor: "#e8f5e9",
      tooltip: "Parents actifs",
    },

    {
      label: "Deleted Parents",
      value: stats?.deletedParents || 0,
      icon: <DeleteIcon fontSize="large" />,
      iconColor: "#d32f2f",
      bgColor: "#ffebee",
      tooltip: "Parents supprimés",
    },
  ];

  return (
    <Grid container spacing={2} mb={3}>
      {data.map((item, i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <StatCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default Parents;
